import React from 'react';
import NavItem from './NavItem';

const Sidebar = ({ navItems, onLogout }) => {
  return (
    <nav className="bg-primary text-white p-2 ">
        <h2 className="text-white text-decoration-none">yuva cure</h2>
      <br />
      <ul className="list-unstyled overflow-scroll" style={{height: '90vh'}}>
        {navItems.map((item, index) => (
          <NavItem key={index} navLink={item.navLink} navItem={item.navItem} />
        ))}
        <li className="mt-5" onClick={onLogout}>
          <i className="fas fa-power-off"></i> Logout
        </li>
      </ul>
    </nav>
  );
};

export default Sidebar;
